import { useNavigate } from "react-router-dom";

export default function Navbar({ onMenuClick }) {
    const navigate = useNavigate();

    const username = localStorage.getItem("username");
    const role = localStorage.getItem("role");

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("permissions");
        localStorage.removeItem("username");
        localStorage.removeItem("studentId");
        localStorage.removeItem("parentToken");

        alert("Logged out successfully");

        navigate("/");
    };

    return (
        <div className="bg-white shadow px-3 sm:px-6 py-3 sm:py-4 flex justify-between items-center gap-3">

            {/* Left side */}
            <div className="flex items-center gap-3 min-w-0">

                {/* Mobile menu button */}
                <button
                    type="button"
                    onClick={onMenuClick}
                    className="md:hidden bg-blue-900 text-white w-10 h-10 rounded-lg flex items-center justify-center text-xl flex-shrink-0"
                    aria-label="Open menu"
                >
                    ☰
                </button>

                <div className="min-w-0">
                    <h1 className="text-lg sm:text-xl font-bold truncate">
                        School ERP
                    </h1>

                    <p className="text-xs sm:text-sm text-gray-600 truncate">
                        Welcome, {username} ({role})
                    </p>
                </div>

            </div>

            {/* Logout */}
            <button
                onClick={handleLogout}
                className="bg-red-600 hover:bg-red-700 text-white px-3 sm:px-4 py-2 rounded text-sm sm:text-base flex-shrink-0"
            >
                Logout
            </button>

        </div>
    );
}